const PREFIX = 'signup.form';

export const SIGNUP_FORM_STARTED_TAG = `${PREFIX}.started`;

export const SIGNUP_FORM_SUBMIT_TAG = `${PREFIX}.submit`;

export const SIGNUP_FORM_SUCCESS_TAG = `${PREFIX}.success`;

/**
 * Not a failure: the v3 score came back low and the visitor is shown the checkbox. Their next
 * submission continues this attempt, so the challenge is counted on its own rather than under
 * `failure`, and the resubmit is not counted as a second `submit`.
 */
export const SIGNUP_FORM_RECAPTCHA_CHALLENGE_TAG = `${PREFIX}.recaptcha_challenge`;

export const SIGNUP_FAILURE_REASONS = {
    createUserError: 'create_user_error',
    loginAfterSignupFailed: 'login_after_signup_failed',
} as const;

export type SignUpFailureReason = (typeof SIGNUP_FAILURE_REASONS)[keyof typeof SIGNUP_FAILURE_REASONS];

/**
 * Reasons are a closed set rather than the underlying error text, which would put unbounded
 * cardinality into `silver_telemetry_event`.
 */
export function signUpFailureTag(reason: SignUpFailureReason): string {
    return `${PREFIX}.failure.${reason}`;
}
